<template>
    
    <q-page class="" >
        <div class="bg-white" style="border-radius: 1rem !important; position: fixed !important; background: #fff !important; width: 100% !important; z-index: 10 !important;">
            <div class="q-px-lg q-py-sm col-xs-12 col-md-9" style="background-color: #feecf0 !important; color: #cc0f35 !important;">
                <timer ref="timer"/>
            </div>
        </div>
        <div class="row q-px-lg" style="padding-bottom: 78px;">
        
        <div class="col-xs-12 col-md-9 rounded-borders marginTopContent" style=" margin-right:auto; margin-bottom:0; margin-left:auto;">
        
        <q-stepper 
            id="mainStepper"
            ref="stepper" v-model="StoreStateAD.step"  animated contractable 
            class="no-shadow q-pt-lg"
            active-color="primary"
            inactive-color="grey" style="border-radius: 1rem !important; ">

            <q-step class="QStepHead" :done="StoreStateAD.step > 2" :header-nav="StoreStateAD.step > 2" :name="2" prefix="1" :title='$t("stepper.title1")' 
                style="background: white !important; border-radius: 1rem;">
            <!--     <q-stepper v-model="verticalStepper" header-nav  vertical color="primary" animated flat> -->
                <div class="stepTitle q-px-lg q-py-md row">
                    <div class="q-mr-md stepIndex" style="">1</div>
                    <b>{{$t("stepper.title1")}}</b>
                </div>
             
                    <q-stepper 
                        v-model="verticalStepper"
                        vertical
                        active-color="primary"
                        inactive-color="grey" 
                        animated class=""
                        style="border-radius: 1rem; box-shadow: none;">

                    <q-step :name="1" prefix="i"  :title='$t("Applicant-Detail.title")' :done="done1">
                        <q-form @submit="SubmitApplicantDetail" class="">
                         
                            <AD></AD>
                            <q-stepper-navigation class="float-right q-pa-md">
                                <q-btn type="submit" color="primary" :label='$t("common.continueBtn")' @click="scrollPositionToTop"></q-btn>
                                
                            </q-stepper-navigation>
                        </q-form>
                    </q-step>

                    <q-step :name="2" prefix="ii" :title='$t("Employment-Detail.title")'  :done="done2" >
                        <q-form @submit="SubmitEmploymentDetail" class="">
                            <ED ref="EmpDet"></ED>
                            <q-stepper-navigation class="float-right q-pa-md">
                                <!-- <q-btn v-if="verticalStepper > 1" flat color="primary" @click="$refs.stepper.previous()" 
                                    label="Back" class="q-mr-sm" style="background: transparent !important; color: grey !important;" /> -->
                                <q-btn type="submit" color="primary" :label='$t("common.continueBtn")' @click="scrollPositionToTop"></q-btn>
                                
                            </q-stepper-navigation>
                        </q-form>
                    </q-step>
                    <q-step :name="3" prefix="iii" :title='$t("Fatca-Detail.title")'  :done="done3">
                        <q-form @submit="SubmitFatcaDetail" class="">
                            <FATCA ref="FATCA"></FATCA>
                            <q-stepper-navigation class="float-right q-pa-md">
                                <q-btn type="submit" color="primary" :label='"Save"' @click="scrollPositionToTop"></q-btn>
                            </q-stepper-navigation>
                        </q-form>
                    </q-step>
                    
                </q-stepper>
            </q-step>
            <q-step class="QStepHead" :done="StoreStateAD.step > 5" :header-nav="StoreStateAD.step > 5" done-color="teal-5"  :name="5" prefix="2" :title='$t("stepper.title2")' style="background: white !important; border-radius: 1rem;">
                <div class="stepTitle q-px-lg q-py-md row">
                    <div class="q-mr-md stepIndex" style="">2</div>
                    <b>{{$t("stepper.title2")}}</b>
                </div>
                <!-- <q-form @submit="toAccountVerification" class="q-gutter-md"> -->
                <Summary @AgreeOnDeclaration="EnableSummaryNextButton()" @DisagreeOnDeclaration="DisableSummaryNextButton()" class="q-pa-sm"/>
                <q-stepper-navigation class="q-pa-md">
                    <Navigation class="" :ShowNextButton=true NextButtonColor="primary" @NextButton="toAccountVerification()" :DisableNextButton="SummaryNextButton"/>
                </q-stepper-navigation>
                <!-- </q-form> -->
            </q-step>
            <q-step class="QStepHead"  done-color="teal-5" :done="StoreStateAD.step > 6" :header-nav="StoreStateAD.step > 6"  :name="6" prefix="3" :title='$t("stepper.title3")'
                style="background: white !important; border-radius: 1rem;">
                <div class="stepTitle q-px-lg q-py-md row">
                    <div class="q-mr-md stepIndex" style="">3</div>
                    <b>{{$t("stepper.title3")}}</b>
                </div>
                <q-form class="">
                    <div class="row q-pa-sm">
                        <div class="col-xs-12 col-md-4" >
                            <Account class="q-pa-md" style="height: 100%;"/>
                        </div>
                        <div class="col-xs-12 col-md-8">
                            <TAC class="q-pa-md" />
                        </div>
                        
                        
                    </div>
                    
                </q-form>
            </q-step>

             <q-step  class="QStepHead" :done="StoreStateAD.step > 7" :header-nav="StoreStateAD.step > 7" done-color="teal-5" :name="7" prefix="4" :title='$t("stepper.title12")'
                 style="background: white !important; border-radius: 1rem 1rem 0 0;">
               
                <div class="stepTitle q-px-lg q-py-md row">
                    <div class="q-mr-md stepIndex" style="">4</div>
                    <b>{{$t("stepper.title12")}}</b>
                </div>
                <q-form @submit="SubmitApplicantCredential" class="">
                    <AC />
                  
                        <q-stepper-navigation class="row float-right q-pa-md" style="margin-right: 0px !important; margin-bottom: 8px; width: 100%; background: white !important; border-radius: 0 0 1rem 1rem;">
                            <div class="col-xs-12 col-md-6 col-lg-5 col-xl-4" style="margin: auto; text-align: right; padding-right: 16px;">
                                <q-btn unelevated type="submit" color="primary" :label='$t("common.continueBtn")' @click="scrollPositionToTop"></q-btn>
                            </div>
                        </q-stepper-navigation>
                    
                </q-form>
            </q-step>
            <q-step class="QStepHead" done-color="teal-5" :done="StoreStateAD.step > 8" :header-nav="StoreStateAD.step > 8"  :name="8" prefix="5" :title='$t("stepper.title4")'
                style="background: white !important; border-radius: 1rem;">
                
                <div class="stepTitle q-px-lg q-py-md row">
                    <div class="q-mr-md stepIndex" style="">5</div>
                    <b>{{$t("stepper.title4")}}</b>
                </div>
                <q-form class="q-pa-sm">
                    <TransactionBuy />
                </q-form>
               
            </q-step>
            <q-step class="QStepHead" done-color="teal-5" :done="StoreStateAD.step > 9" :header-nav="StoreStateAD.step > 9"  :name="9" prefix="6" :title='$t("stepper.title5")'
                style="background: white !important; border-radius: 1rem;">
                <div class="stepTitle q-px-lg q-py-md row">
                    <div class="q-mr-md stepIndex" style="">6</div>
                    <b>{{$t("stepper.title5")}}</b>
                </div>
                <q-form class="">
                    <TAC />
                </q-form>
            </q-step>
        </q-stepper>
        <!-- <div class="bg-white" style="border-radius: 0px 0px 25px 25px">
            <q-card-section>
                
            </q-card-section>
        </div> -->

        <q-dialog v-model="StoreStateAD.OpenDeclaration" :content-css="{minWidth: '60vw', minHeight: '80vh'}" no-backdrop-dismiss>
            <q-card style="min-width:80%;">
                <q-card-section>
                    <q-toolbar slot="header">
                        <q-toolbar-title>
                            Declaration
                        </q-toolbar-title>
                    </q-toolbar>
                    <div class="row">
                        <div class="col">
                            <Declaration ButtonName='"Agree"' class="q-pa-md" />
                         </div>
                    </div> 
                    <div class="row">
                        <div class="col">
                            <Navigation class="q-px-md q-pb-xl" :ShowAgreeButton=true :ShowDisagreeButton=true AgreeButtonColor="primary" @AgreeButton="ToSummary()" @DisagreeButton="CloseDeclaration()" />
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>
        </div>

           <q-dialog v-model="userAlert"  persistent transition-show="scale" transition-hide="scale">
                <q-card style="width: 700px; max-width: 80vw; border-radius: 1rem;">
                <q-card-section>
                    Hi There!
                </q-card-section>
                  <q-card-section>
                      <div class="row">
                          <div class="col">
                              Please key in your mobile number for TAC purpose
                          </div>
                          <div class="col">
                              <q-input
                                    filled
                                    v-model="StoreStateAO.ContactInformation.MobileNo"
                                    label="Phone"
                                    mask="##########"
                                    hint="Mask: ##########"
                                />
                          </div>
                      </div>
                </q-card-section>
                <q-card-section>
                     <Navigation
                        class="q-px-sm"
                        :ShowConfirmButton=true
                        ConfirmButtonColor="primary"
                        @ConfirmButton="Confirmed()"
                    />
                </q-card-section>
                </q-card>
           </q-dialog>



             <q-dialog v-model="loginBox"  persistent transition-show="scale" transition-hide="scale">
                <q-card style="max-width: 380px; border-radius: 1rem; font-family: 'Poppins', sans-serif;" class="q-pa-sm">
                <q-card-section class="">
                    <div style="background: #f5f5f5; border-radius: 0.5rem; padding: 12px;">
                        Email/Phone number is already in use. Please login by using your existing credential or another Email/Phone number.
                    </div>
                </q-card-section>
                  <q-card-section>
                      <q-form @submit="onSubmitLogin"  class="">
                        <div rounded class="">
                            <div class="row">
                                <div class="col-12 text-bold" style="font-size: 16px; margin-bottom: 20px;">
                                    Login
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 ">
                                    User ID *
                                    <q-input ref="input" outlined  v-model="StoreStateAD.loginUserID" bottom-slots  :rules="[val => !!val || '' + $t('common.fieldRequired') +' ', isValidEmail]"  >
                                        <template v-slot:prepend>
                                            <q-icon name="far fa-user-circle"/>
                                        </template>
                                    </q-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 ">
                                    Password
                                    <q-input outlined v-model="StoreStateAD.LoginPassword" v-bind:type="StoreStateAD.isPwd2 ? 'password' : ''" :rules="[val => !!val || '' + $t('common.fieldRequired') +' ']" ref="fldPasswordChange">
                                        <template v-slot:prepend>
                                            <q-icon name="lock" />
                                        </template>
                                        <template v-slot:append>
                                            <q-icon :name="StoreStateAD.isPwd2 ? 'visibility_off' : 'visibility'" class="cursor-pointer" v-on:click="StoreStateAD.isPwd2 = !StoreStateAD.isPwd2"></q-icon>
                                        </template>
                                    </q-input>
                                </div>
                                </div>
                            <div class="row">
                     
                                <div class="col-12 text-right">
                                    <q-btn
                                        flat
                                        color="grey"
                                        size="md"
                                        style="" 
                                        label="Cancel"
                                        @click="closeloginBox()"
                                        class="" >
                                    </q-btn>
                            
                                    <q-btn
                                        unelevated
                                        size="md"
                                        style="background: #ff6666;" 
                                        :loading="submitting"
                                        label="Login"
                                        type="submit" 
                                        class="text-white q-ml-md" >
                                    </q-btn>
                                </div>
                            
                            </div>
                    </div>
                      </q-form>
                </q-card-section>
                </q-card>
           </q-dialog>
           </div>

    </q-page>
    
</template>
<style >
.QStepHead{
    cursor: default;
}

.q-stepper__header--alternative-labels .q-stepper__tab {
    min-height: 90px !important;
}

.q-stepper__nav button {
    background: #ff6666 !important;
}

.q-stepper__header--standard-labels .q-stepper__tab {
    min-height: 55px !important;
}

/* Stepper Header */
.q-stepper__header.row.items-stretch.justify-between.q-stepper__header--standard-labels.q-stepper__header--border {
    margin-bottom: 1rem !important;
    background: white !important;
    border-radius: 1rem !important;
}
@media screen and (max-width: 768px){    
    .q-stepper__header.row.items-stretch.justify-between.q-stepper__header--standard-labels.q-stepper__header--border {
        display: none;
    }
    .marginTopContent{
        margin-top: 95px !important;
    }
}

.stepTitle{
    font-size: 16px;
    border-bottom: 1px solid #d7d7d7;
    position: fixed;
    background: rgb(255 255 255 / 99%);
    z-index: 10;
    width: 100%;
    transform: translate3d(-24px, -83px, 0px);
    text-align: center;
    backdrop-filter: blur(3px);
}
@media screen and (min-width: 769px){
    .stepTitle{
        display: none !important;
    }
    .marginTopContent{
        margin-top: 38px;
    }
}
.stepIndex{
    border-radius: 100%; background: #9e9e9e; color: white; height: 22px; width: 22px; padding: 1px 7px; font-size: 14px;
}

/* space stepper between header and body */
div#mainStepper {
    background: transparent !important;
}

</style>

<script>
import timer from '@/components/timer'
import { mapActions } from 'vuex';

import ACK from '@/components/Acknowledgement.vue'
import TAC from '@/components/TAC.vue'
import Declaration from '@/components/Declaration.vue'
import Navigation from '@/components/NavigationButtons'
import AC from '@/components/ApplicantCredentials.vue'
import AD from '@/components/ApplicantDetails.vue'
import FATCA from '@/components/FATCA.vue'
import ED from "@/components/EmploymentDetails.vue";
import Summary from "@/views/SummaryAccountOpening.vue"
import store from '../store';
import TransactionBuy from '@/views/TransactionsConfirmation.vue'
import Account from '@/components/AccountDetails.vue'


import {
  Notify
} from 'quasar'
export default {
    name: 'LandingPage',
    components:{
        Navigation,    
        Declaration,
        AC,
        AD,
        ED,
        FATCA,
        TAC,
        ACK,
        Summary,
        TransactionBuy,
        timer,
        Account
    },
    data(){
        return{
            StoreStateCD: store.state.CD,
            StoreStateLookup : store.state.Lookup,
            StoreStateAD : store.state.AD,
            StoreStateFATCA : store.state.FATCA,
            StoreStateED : store.state.ED,
            StoreStateAO : store.state.AOD,
            StoreStateT : store.state.Transactions,
            StoreStateCD : store.state.CD,
            StoreStateAPI : store.state.API,
            StoreStateTransaction : store.state.Transactions,
            StoreStateLogin: store.state.Login,
            timeout: null,            
            verticalStepper : 1,
            SummaryNextButton : true,
            done1: false,
            done2:false,
            done3:false,
            personalDetail:false,
            empDetails: false,
            fatcaDetails:false,
            userAlert:false,
            isIEBrowser: false,
            BrowserType:'',            
            IAkaunUrl : process.env.VUE_APP_IAKAUN_URL ,
            doTacVerify: process.env.VUE_APP_TAC_VERIFY,
            apiCall : true,
            counter:1,
            loginBox:false,
            submitting: false,
        }
    },  

    
    
     created() {
     var ua = window.navigator.userAgent; 
        var msie = ua.indexOf('MSIE '); 
        if (msie > 0) { 
          this.isIEBrowser = true;
            // IE 10 or older, return version number 
          this.BrowserType  = 'IE ' + parseInt(ua.substring( msie + 5, ua.indexOf('.', msie)), 10)
        } 
        var trident = ua.indexOf('Trident/'); 
        if (trident > 0) { 
            // IE 11, return version number 
          this.isIEBrowser = true;
          var rv = ua.indexOf('rv:'); 
          this.BrowserType ='IE ' + parseInt(ua.substring(   rv + 3, ua.indexOf('.', rv)), 10)
            
        } 
        var edge = ua.indexOf('Edge/'); 
        if (edge > 0) { 
          
            //Edge (IE 12+), return version number 
           this.isIEBrowser = true;
           this.BrowserType = 'IE ' + parseInt(ua.substring(   edge + 5, ua.indexOf('.', edge)), 10)
        }

      if(this.isIEBrowser === true){
         this.$q.dialog({
              title: 'Alert',
              message: "Hi, Our application is not supported in : "+this.BrowserType+". Best use in Google Chrome or Mozilla Firefox. You may continue by Copy and Paste the URL: https://investdev.affinhwangam.com" +
              this.StoreStateLogin.RouteToPath+" in Google Chrome or Mozilla Firefox"
          }).onOk(() => {
              this.triggerLogout();
          })   
     }
  },
 async mounted(){

        store.commit("ResetAODetails");        
        store.commit("ResetState_ClientDetails");
        store.commit("ResetTransactionDetails");
        store.commit("ResetState_AD");
        store.commit("ResetState_FATCA");
        store.commit("ResetState_ED");
         

        this.StoreStateT.inComingTransaction ='landingpage'
        this.StoreStateAD.step= 2
        var url = new URL(window.location.href);
        var url_string = url.search;

        var appID = url.searchParams.get('appId');
        
        this.StoreStateLogin.incomingAppID = appID
        this.StoreStateFATCA.PersonalAsset = false;
        this.StoreStateED.EmploymentStatus =''
        this.StoreStateED.BusinessNature = ''
        this.StoreStateED.BusinessNature2=''

       // appID ='1a6e13ff-d8a7-4247-8813-660d9fb02010'
        //appID ='31692a2e-6281-42a1-92c9-9ed63674bcfe' -->
        // appID = '3986f413-d4f4-436f-80fd-83b18b3d88a0'
        //appID = '99787452-514a-4c88-9ecc-c38465b3eb74'
        // appID = 'e926eade-195e-48f8-ad1d-d6c5895a3bab'
        //appID='94247f31-0552-4cbb-9fc1-ee9343d68a44'
        
            if(appID != undefined){
                //move the whole function into this
                this.$q.loading.show({
                spinnerSize : 50
            })
         
            while(this.counter<5){
              await this.EmisApp()
                .then(res=>{
                    if((this.counter===4)&&(this.apiCall===false)){
                        this.$q.loading.hide()
                        this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + '-> Unable to retrieve API TOKEN' 
                        });
                        this.$router.push({ name: 'Maintenance'});
                        console.log('error ->' + this.counter)
                    }

                    this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'LandingPage--> ' + url_string
                  });
                })
                this.counter++  
            }
        }else{
            this.$store.dispatch('Logging',{
                appid : '2',
                typeid :'4', 
                str : 'EMPTY ID CALL DETECTED' 
            });
            this.$router.push({ name: 'Maintenance'});
        }
    },
    methods:{
         ...mapActions([
             "GETEmisToken",
            "GeteMisLookup",
            "RequestTAC",
            "PostOnboardingSelf",
            "GetOnboardingSelf",
            "GetEmisApplication",
            "GetLookup",
            "CIFInfo",
            "GetListOfFundForOnboarding", 
            "getEmisDocumentDownloadLink",
            "triggerLogout",
            "TriggerAkamaiAccountCreation",
            "TriggerAkamaiLogin",
        ]),
 isValidEmail:function (val) {
        const emailPattern = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
        return emailPattern.test(val) || 'Invalid email';
        },
    async EmisApp(){
       return new Promise((resolve, reject) => {
        try{
            this.GETEmisToken({
                ApplicationId:this.StoreStateLogin.incomingAppID
            })
            .then(res=>{

              this.$httpClient.defaults.headers['Authorization'] = "Bearer " + this.StoreStateLogin.AkamaiToken
              
                if(res === true){
                    this.apiCall = true
                    this.counter = 4
                
                    this.GeteMisLookup()
                    .then(res=>{
                        this.$store.dispatch('Logging',{
                            appid : '2',
                            typeid :'4', 
                            str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GeteMisLookup(Onboard), res -> ' + res
                        });

                        if(res == true){
                            this.GetLookup()
                            .then(res=>{
                                this.$store.dispatch('Logging',{
                                    appid : '2',
                                    typeid :'4', 
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetLookup(Onboard), res -> ' + res
                                });

                            if(res== true){
                                this.GetEmisApplication({
                                ApplicationId :this.StoreStateLogin.incomingAppID
                            })
                            .then(res =>{
                                this.$store.dispatch('Logging',{
                                    appid : '2',
                                    typeid :'4', 
                                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetEmisApplication(Onboard), res -> ' + res
                                });                       

                                if(res == true){
                                    var userID = '';
                                    if(this.StoreStateAO.PersonalInformation.IdType ==='NewIC'){
                                        userID = this.StoreStateAO.PersonalInformation.NRIC
                                    }else{
                                        userID = this.StoreStateAO.PersonalInformation.OldID
                                    }

                                    this.CIFInfo({
                                        UserId:userID
                                        }).then(res =>{
                                            this.$store.dispatch('Logging',{
                                                appid : '2',
                                                typeid :'4', 
                                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'CIFInfo (Onboard), res -> ' + res
                                            });

                                            if(res == true){
                                                //TODO --> uncomment before deploy
                                                this.TimeInit();
                                                this.GetListOfFundForOnboarding()
                                                .then(res => {
                                                    resolve(this.apiCall) 
                                                    if (res != 'error') {
                                                        if(this.StoreStateTransaction.Transaction.Investment.length > 0 ){
                                                                for(var i=0; i<this.StoreStateTransaction.Transaction.Investment.length; i++ ){
                                                                    var fundCode = '';
                                                                    this.getEmisDocumentDownloadLink({
                                                                        FundCode:this.StoreStateTransaction.Transaction.Investment[i].productCode
                                                                    })
                                                                }
                                                            } 
                                                    }
                                                })
                                                this.$q.loading.hide()
                                            }else  {
                                                this.$q.dialog({
                                                    title : 'Error',
                                                    message : this.$t("common.restartTrnx")
                                                })
                                                this.$q.loading.hide()
                                            }
                                        })
                                        }else if(res==false) {
                                                this.$q.dialog({
                                                    title : 'Error',
                                                    message : this.$t("common.restartTrnx")
                                                })
                                                this.$q.loading.hide()
                                        }else if(res === -1){
                                            this.$q.loading.hide()
                                            this.$q.dialog({
                                                title : 'Warning',
                                                message : 'Sorry, Looks like your Transaction is complete. Please restart your transaction from I-Akaun.',
                                                persistent : true
                                            }).onOk(() => {
                                                // console.log('OK')
                                                this.triggerLogout();
                                            }) 
                                        }
                                        else{
                                            this.$q.loading.hide()
                                            this.$router.push({ name: 'Maintenance'});    
                                        }
                                    })
                                }else{
                                this.$q.dialog({
                                    title : 'Message',
                                    message :this.$t("common.secondLookUp")
                                })
                                    this.$q.loading.hide()
                                }
                                })
                        }else{
                            this.$q.dialog({
                                title : 'Error',
                                message :this.$t("common.firstLookUp")
                            })
                            this.$q.loading.hide()
                        }
                    }) 
                }else{
                    this.apiCall = false
                    resolve(this.apiCall) 
                    /* 
                    this.$q.loading.hide()
                    this.$router.push({ name: 'Maintenance'}); */
                }  
                })
        }catch(err) {
          this.apiCall = false
          reject( this.apiCall)
        }
      })
    },

    scrollPositionToTop(){
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },

    startTimer: function(duration, display) {
      var timer = duration,
        minutes,
        seconds;
    },
    TimeInit() {
      var display = document.querySelector("#time");
      var duration = this.StoreStateAO.LandingPageTimer * 60;
      
     // alert(" duration ->" + duration)
     // alert(" LandingPageTimer ->" + this.StoreStateAO.LandingPageTimer)

      if(0 == duration){
        this.$alert(this.$t("common.timeup"))
        .then( () => {
          window.location.href = this.IAkaunUrl 
          //'https://iakaunuat2.epf.gov.my/member/member/login'
        });
      } 
      var timer = duration,
        minutes,
        seconds;
      this.timeout = setInterval(() => {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        display.textContent = minutes + ":" + seconds;

        if (--timer < 0) {
          timer = duration;
        } else if (timer == 0) {
       
          //this.$alert("Time up! We will redirect to main page").then(() => {this.$router.push({ path: '/invsnap'})});
          this.$alert(this.$t("common.timeup"))
          .then(
            () => {window.location.href = this.IAkaunUrl 
            //'https://iakaunuat2.epf.gov.my/member/member/login'
            });
  
        }
      }, 1000);
    },
        Confirmed:function(){
            
        this.userAlert = false
        },
        EnableSummaryNextButton(){
            this.SummaryNextButton = false
        },
        DisableSummaryNextButton(){
            this.SummaryNextButton = true
        },
        toAccountVerification:function(){
        
            //TO DO UNCOMMENT THIS REQUEST TAC
            //this.doTacVerify ='true'
            if(this.doTacVerify === 'true'){
              // this.StoreStateAO.ContactInformation.MobileNo  ='0149638728'
                this.formatMobileNo();

                this.done5 = true;
                this.StoreStateAD.step = 6;  
                var tempval = ''
                if(this.StoreStateAO.PersonalInformation.NRIC!=''){
                    tempval = this.StoreStateAO.PersonalInformation.NRIC;
                }else if(this.StoreStateAO.PersonalInformation.OldID!=''){
                    tempval = this.StoreStateAO.PersonalInformation.OldID;
                }
                
                this.RequestTAC({
                
                    CustomerTelMobile : this.StoreStateAO.ContactInformation.MobileNo,
                    Purpose : 'EMIS - Account Verification',
                    CustomerId : tempval,
                    RIDType : ''
                })
                .then(res=>{
                    this.$store.dispatch('Logging',{
                        appid : '2',
                        typeid :'4', 
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TAC Request-> ' + res
                    });

                    if(res===true){
                        this.done5 = true;
                        this.StoreStateAD.step = 6;   
                        this.$q.dialog({
                            title :  this.$t("PopUp.tacheader") ,
                            message : this.$t("PopUp.tacbody")  
                        })
                    }else{
                        this.done5 = true;
                        this.StoreStateAD.step = 6; 
                        this.$q.dialog({
                            title :  'Warning',
                            message :  res
                        })
                    }
                })
            }else{
                this.done5 = true;
                this.StoreStateAD.step = 6;   
                this.$q.dialog({
                    title :  this.$t("PopUp.tacheader") ,
                    message : this.$t("PopUp.tacbody") + this.tempMobileNo 
                })
            }
         
        },
        toApplicantSummary: function(){
            //need to POST data
       //     alert('here')
            this.StoreStateAD.OpenDeclaration = false;
            this.StoreStateAD.step =5; 
        },
        SubmitFatcaDetail:function(){
            //this.generateUId()
            //this.StoreStateAD.OpenDeclaration = true;
            if((this.empDetails==true)&&(this.personalDetail==true)){
                 this.$q.loading.show()
                this.ToSummary()
                this.verticalStepper = 4
                this.done3 = true; 
            }else{
                 this.$q.dialog({
                        title : 'Message',
                        message : this.$t("common.missingField") 
                    })
            }
            
        },
        SubmitEmploymentDetail:function(){
        //    alert()
            this.empDetails = true
            this.verticalStepper = 3
            this.done2 = true; 
            //this.StoreStateAD.step = "4"; 
        },
        SubmitApplicantCredential : function(){
            this.$q.loading.show({
                spinnerSize : 50
            })
            this.TriggerAkamaiAccountCreation().then(resp=>{
               this.$store.dispatch('Logging',{
                        appid : '2',
                        typeid :'4', 
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TriggerAkamaiAccountCreation-> ' + resp
                    });

                this.$q.loading.hide();

                if(resp.Status === "1"){
                   /*  this.StoreStateAO.Onboardemail = this.StoreStateAD.Creation_loginUserID

                    console.log('this.StoreStateAO.Onboardemail',this.StoreStateAO.Onboardemail) */
                    this.StoreStateAD.Creation_uuid = resp.UserID
                    this.done1 = true; 
                    this.StoreStateAD.step = 8;
                }else if(resp.Status === "-1"){
                    this.loginBox = true
                }else{
                    this.$q.dialog({
                        title : 'Message',
                        message : resp.Message
                    })
                }
            }).catch(error=>{
                
                this.$q.loading.hide();
                this.$q.dialog({
                        title : 'Message',
                        message : error
                    })
            })
            /* this.done1 = true; 
            this.StoreStateAD.step = 2;  */
        },
        closeloginBox:function(){
                this.loginBox = false 
        },
        onSubmitLogin:function(){
                this.$q.loading.show({
                spinnerSize : 50
            })
             this.submitting = true
       
            this.TriggerAkamaiLogin().then(resp=>{
                  this.$store.dispatch('Logging',{
                        appid : '2',
                        typeid :'4', 
                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TriggerAkamaiLogin-> ' + resp
                    });


                 this.submitting = false
                this.$q.loading.hide();
                 if(resp.Status === "1"){
                    this.loginBox = false 
                    this.StoreStateAD.Creation_uuid = resp.UserInfo.UserID
                    this.done1 = true; 
                    this.StoreStateAD.step = 8; 
                }else{
                    this.$q.dialog({
                        title : 'Message',
                        message : resp.Message
                    })
                }
            }).catch(error=>{
                
                this.$q.loading.hide();
                this.$q.dialog({
                        title : 'Message',
                        message : error
                    })
            })
            
        },
        SubmitApplicantDetail :function () {

            if((this.StoreStateAO.PersonalInformation.InvestmentPurpose.length>0)&&(this.StoreStateAO.PersonalInformation.SourceOfWealth.length>0)){
                this.personalDetail = true;
                this.verticalStepper = 2
                this.done2 = true;   
            }else{
                if(this.StoreStateAO.PersonalInformation.InvestmentPurpose.length<=0){
                    this.personalDetail = false;
                    this.verticalStepper = 1
                    this.done2 = false;
                    this.$q.dialog({
                        title : 'Message',
                        message : this.$t("Applicant-Detail.investmentpurposerequired") 
                    })
                    return false
                }
                if(this.StoreStateAO.PersonalInformation.SourceOfWealth.length<=0){
                    this.personalDetail = false;
                    this.verticalStepper = 1
                    this.done2 = false;
                    this.$q.dialog({
                        title : 'Message',
                        message : this.$t("Applicant-Detail.sourceofwealthrequired") 
                    })
                    return false
                }
            }                       
        },
        Next : function(params) {
            if((this.StoreStateAD.SubmitApplicantCredential!=false) && (this.StoreStateAD.SamePassword==true)){
                this.$refs.stepper.next();
                
                this.$q.loading.hide()
            }
        },
        ToSummary:function(){
            var tempId="";
            if(this.StoreStateAO.ApplicationId !=""){
                tempId = this.StoreStateAO.ApplicationId
            }else if(this.StoreStateAO.PersonalInformation.NRIC !=""){
                tempId = this.StoreStateAO.PersonalInformation.NRIC;
            }else if (this.StoreStateAO.PersonalInformation.OldID != ""){
                tempId = this.StoreStateAO.PersonalInformation.OldID
            }

            this.PostOnboardingSelf({
                ApplicationId : tempId,
                Status : "Pending Investor",
                UserId : tempId
            })
            .then(res=>{

                this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'PostOnboardingSelf (Onboard), res -> ' + res
                });

                if(res===true){
                    this.StoreStateAD.OpenDeclaration = false;
                    this.$refs.stepper.next();
                       if(this.StoreStateCD.ApplicantId != ""){

                        // Added 8 seconds delay to get the updated data from the API to handle empty {} from GET endpoint
                        setTimeout(() => {
                          this.GetOnboardingSelf({
                            ApplicationId: this.StoreStateCD.ApplicantId
                          })
                          .then(res => {
                              this.$store.dispatch('Logging', {
                                  appid: '2',
                                  typeid: '4',
                                  str: 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetOnboardingSelf (Onboard), res -> ' + res
                              });
                              this.$q.loading.hide();
                          });
                      }, 8000);
                        }else{
                            this.$q.loading.hide()
                        }
                }
                else{
                    this.StoreStateAD.OpenDeclaration = false;
                    this.$refs.stepper.next(); 
                } 
            })
        },
        CloseDeclaration:function(){
            this.StoreStateAD.OpenDeclaration = false;
            // close declaraion popup
        },
        formatMobileNo:function() {

       // this.StoreStateAO.ContactInformation.MobileNo  ='0149638728'
        var mobileNo = this.StoreStateAO.ContactInformation.MobileNo           
        this.tempMobileNo =  '01x- xxxx ' + mobileNo.slice(-4) ;
      },
      
    }
}
</script>